// extracted by mini-css-extract-plugin
export var csatScore = "_mi-5";
export var header = "_mi-1";
export var panelWrapper = "_mi-2";
export var postPreview = "_mi-3";
export var rightContent = "_mi-0";
export var wrappingText = "_mi-4";